import { RetentionConflictDetails } from "@dashboard-v3/api";
import {
  getErrorCode,
  getErrorDescription,
} from "utils/apiRequestWithErrorCode";

export default function getRetentionConflictDetails(
  error: unknown
): RetentionConflictDetails | null {
  if (getErrorCode(error) !== "RETENTION_CONFLICT") return null;

  return getErrorDescription(error) as RetentionConflictDetails;
}
